import BaseClient from './BaseClient';

class AdminPhoneNumbersClient extends BaseClient {
    searchLocal(payload) {
        const url = `/api/admin/search/phone-numbers/local`;
        return this.makeCoreApiRequest(url, 'get', null, payload);
    }

    searchTollFree(payload) {
        const url = `/api/admin/search/phone-numbers/toll-free`;
        return this.makeCoreApiRequest(url, 'get', null, payload);
    }

    create(teamId, data) {
        const url = `/api/admin/teams/${teamId}/phone-numbers`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    update(teamId, phoneNumberId, data) {
        const url = `/api/admin/teams/${teamId}/phone-numbers/${phoneNumberId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    getVoiceChanges(teamId, phoneNumberId, params, config) {
        const url = `/api/admin/teams/${teamId}/phone-numbers/${phoneNumberId}/voice-changes`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    delete(teamId, phoneNumberId) {
        const url = `/api/admin/teams/${teamId}/phone-numbers/${phoneNumberId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    host(teamId, data) {
        const url = `/api/admin/teams/${teamId}/phone-numbers/host`;
        return this.makeCoreApiRequest(url, 'post', data);
    }
}

export default new AdminPhoneNumbersClient();
